<template>
  <div id="js-checkout-footer">
    <!-- todo: can we move this to /includes? -->
    <footer
      class="checkout-footer d-none d-md-flex"
      v-bind:class="[
        $store.state.cart.curbsideFulfillmentMode === 'delivery'
          ? 'checkout-footer--spread'
          : '',
      ]"
    >
      <!-- Tip is shown for delivery only -->
      <div>
        <cart-gratuity
          v-if="
            $store.state.cart.curbsideFulfillmentMode === 'delivery' &&
            this.onCheckoutStep &&
            $store.state.cart.gratuity
          "
          :cart-total="$store.state.cart.priceInfo.itemTotal.amount"
          :location="'desktop-footer'"
        >
        </cart-gratuity>
      </div>

      <div class="d-md-block">
        <!-- Legal copy on sticky footer for desktop. Visible with Place Order Button. -->
        <div class="mb-2" v-if="btnRoutePath === '/orderconfirmation'">
          <small
            >By clicking Place order, I agree to the
            <versioned-content-link contentType="TERMS_AND_CONDITIONS"
              >H&#8209;E&#8209;B Terms &amp; Conditions</versioned-content-link
            >
            and
            <versioned-content-link contentType="PRIVACY_POLICY"
              >Privacy Policy</versioned-content-link
            >.</small
          >
        </div>

        <div class="sticky-footer-group">
          <span v-if="$store.state.cart.priceInfo" class="mr-3"
            >Est. total:
            <strong>{{
              $store.state.cart.priceInfo.total.formattedAmount
            }}</strong></span
          >
          <!-- Skip past interstitial button -->
          <a
            :href="ageVerificationRequired ? '/verify-age' : '/checkout'"
            v-if="this.onPrecheckoutStep"
            class="btn place-order-btn btn-primary btn-primary--blue">
            Continue
          </a>

          <!-- Place Order button -->
          <checkout-place-order-button
            v-if="btnRoutePath == '/orderconfirmation'"
          ></checkout-place-order-button>

          <!-- Go to checkout page button -->
          <proceed-to-checkout-button
            v-if="this.onCartStep"
            class="mb-sm-3 mb-md-0"
          ></proceed-to-checkout-button>
        </div>
      </div>
    </footer>

    <!-- Start mobile footer -->
    <footer
      class="checkout-footer-mobile d-flex d-md-none"
      :class="isExpanded ? 'checkout-footer-mobile--expanded' : ''"
    >
      <div class="w-100 text-center" @click="toggleFooter()">
        <img
          src="/img/wide-caret.svg"
          :class="isExpanded ? 'caret-isExpanded' : ''"
          class="caret"
          aria-hidden="true"
        />
      </div>
      <div v-if="!isExpanded" class="item-price-group">
        <div class="item-text item-text--lg">Est. total</div>
        <div
          class="item-text item-text--heavy item-text--heavy-lg"
          v-if="$store.state.cart.priceInfo"
        >
          {{ $store.state.cart.priceInfo.total.formattedAmount }}
        </div>
      </div>

      <div v-if="isExpanded">
        <cart-total v-bind="cartTotalProps" placement="footer"></cart-total>

        <cart-gratuity
          v-if="
            $store.state.cart.curbsideFulfillmentMode === 'delivery' &&
            this.onCheckoutStep &&
            $store.state.cart.gratuity
          "
          :cart-total="$store.state.cart.priceInfo.itemTotal.amount"
          :location="'footer'"
        >
        </cart-gratuity>
      </div>

      <!-- Legal copy for mobile sticky footer. Visible with Place Order button. -->
      <div class="mb-3" v-if="btnRoutePath === '/orderconfirmation'">
        <small
          >By clicking Place order, I agree to the
          <versioned-content-link contentType="TERMS_AND_CONDITIONS">
            H&#8209;E&#8209;B Terms &amp; Conditions
          </versioned-content-link>
          and
          <versioned-content-link contentType="PRIVACY_POLICY">
            Privacy Policy
          </versioned-content-link>
          .</small
        >
      </div>

      <!-- Skip past interstitial button -->
      <a
        :href="ageVerificationRequired ? '/verify-age' : '/checkout'"
        v-if="this.onPrecheckoutStep"
        class="btn place-order-btn btn-primary btn-primary--blue"
        >Continue</a
      >

      <!-- Place Order button -->
      <checkout-place-order-button
        v-if="btnRoutePath === '/orderconfirmation'"
      ></checkout-place-order-button>

      <!-- Go to checkout page button -->
      <proceed-to-checkout-button
        v-if="this.onCartStep"
        class="mb-2"
      ></proceed-to-checkout-button>

      <div v-show="isExpanded">
        <order-note></order-note>
        <promo-code
          :expanded="cartTotalCardInfo.showPromoCodeInput"
          class="promo-component"
        ></promo-code>
        <div class="mt-2">
          Prices may vary based on substitutions and final weight of some items.
        </div>
        <div class="mt-2" v-show="markupMessage">{{ markupMessage }}</div>
      </div>
    </footer>
    <!-- End mobile footer -->
  </div>
</template>

<script>
import CartPromoCode from "./cart/CartPromoCode";
import CartOrderNote from "./cart/CartOrderNote";
import CartTotal from "./cart/CartTotal";
import CartGratuity from "./cart/CartGratuity";
import checkoutPlaceOrderButton from "./checkout/CheckoutPlaceOrderButton";
import checkoutNowButton from "./checkout/CheckoutNowButton";
import VersionedContentLink from "./VersionedContentLink";
import { mapState } from 'vuex'

export default {
  name: "NavigationFooter",
  components: {
    "promo-code": CartPromoCode,
    "order-note": CartOrderNote,
    "cart-total": CartTotal,
    "cart-gratuity": CartGratuity,
    "checkout-place-order-button": checkoutPlaceOrderButton,
    "proceed-to-checkout-button": checkoutNowButton,
    "versioned-content-link": VersionedContentLink,
  },
  props: {
    cartTotalCardInfo: Object,
  },
  data() {
    return {
      isExpanded: false,
      submitButtonText: this.cartTotalCardInfo.submitButtonText,
      btnRoutePath: this.cartTotalCardInfo.btnRoutePath,
    };
  },
  computed: {
    ...mapState({
        cartMarkup: state => state.cart.markup,
        cartContainsBestAvailableItem: state =>  state.cart.containsBestAvailableItem,
        ageVerificationRequired: state => state.cart.ageVerificationRequired,
      }
    ),
    currentRoute() {
      return this.$router.currentRoute.name.toLowerCase();
    },
    onCartStep() {
      return this.currentRoute === 'cart'
    },
    onPrecheckoutStep() {
      return this.currentRoute === 'precheckout'
    },
    onCheckoutStep() {
      return this.currentRoute === 'checkout'
    },
    markupMessage() {
      // Duplicated from CartTotalCard.vue
      // markup should be format XP where X is the markup percent, so we can trim the P to format it as a percent
      if (
        !this.cartMarkup ||
        this.cartMarkup === "0P"
      ) {
        return null;
      }
      return `*${
        this.cartContainsBestAvailableItem ? "*" : ""
      } Online prices may vary from in-store prices.`;
    },
    cartTotalProps() {
      return {
        ...this.cartTotalCardInfo,
        hasMarkup: !!this.markupMessage,
      };
    },
  },
  methods: {
    setOrderNote: function () {
      this.$store.dispatch("cart/POST_ORDER_NOTE", this.orderNote);
    },
    toggleFooter: function () {
      this.isExpanded = !this.isExpanded;
      // Add padding to the container so that user can still reach the bottom of the page
      var footer = document.getElementById("js-checkout-footer");
      var container = document.getElementById("curbsideCheckout");
      this.$nextTick().then(function () {
        container.style.paddingBottom = footer.clientHeight + "px";
      });
    },
  },
  mounted() {
    if (this.btnRoutePath === "/orderconfirmation") {
      this.$store.dispatch("versionedContent/GET_VERSIONED_CONTENT");
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/lib";

.sticky-footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: z-index("checkout-mobile-drawer");
}

.checkout-footer {
  position: fixed;
  bottom: 0;
  width: 100%;
}

strong {
  font-weight: $font-weight-bold;
}

.order-note-submit {
  position: absolute;
  right: 0;
}

.promo-component {
  .alert {
    margin: 0;
  }
}

.caret {
  transition: transform 1s ease;
}

.caret-isExpanded {
  transform: rotateX(180deg);
}

.item-text {
  color: $color-text-dark;
  font-family: $font-standard-text;
  font-size: 14px;
  line-height: 19px;

  &--lg {
    font-size: 18px;
  }
}

.item-text--heavy {
  font-weight: $font-weight-bold;

  &-lg {
    font-size: 25px;
  }
}

.item-text--red {
  color: #dc291e;
  font-weight: bold;
  font-size: 16px;
}

.item-price-group {
  display: flex;
  justify-content: space-between;
  padding-bottom: 14px;
}

.checkout-footer-mobile {
  padding: 8px;
  display: flex;
  flex-direction: column;
  background: $color-text-white;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.15);

  &--expanded {
    padding: 16px 21px;
  }
}

.sticky-footer-group {
  display: flex;
  align-items: center;
  color: $color-text-dark;
  font-family: $font-standard-text;
  font-size: 21px;
  line-height: 28px;
  white-space: nowrap;
  // justify-content: space-between;
  justify-content: flex-end;
}

.place-order-btn {
  height: 40px;
  // width: 100%;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  min-width: 158px;
  display: flex;
  align-items: center;
  justify-content: center;

  &--lg {
    height: 100%;
    min-height: 52px;
    font-size: 19px;
  }
}

a.place-order-btn {
  &:hover {
    color: $color-text-white;
  }
}

.footer-form {
  display: flex;
  flex-direction: row;
  align-items: center;

  form {
    width: 100%;
  }
}

@media screen and (min-width: $breakpoint-tablet) {
  .checkout-footer {
    padding: 16px 90px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    background: $color-text-white;
    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.15);
  }

  .checkout-footer--spread {
    justify-content: space-between;
  }
}
</style>

<docs>
    The Vue component for a "sticky" footer.

    ```jsx
        const footerInfo = {
            cartTotalButtonProp: {
                submitButtonText: 'Checkout Now'
            }
        };

        <sticky-footer v-bind:submitButtonText="cartTotalButtonProp.submitButtonText"></sticky-footer>

        <div class="footer-form" v-if="isDelivery">
            <strong>Tip Your Driver</strong>
            <form>
                <input>
                <select>
                    <option>
                        {{ option }}
                    </option>
                </select>
            </form>
        </div>

    ```

    The `isDelivery` property is checking to see if the user is going to be using the delivery checkout option. If this is true the gratuity input option will be in the bottom left corner.

</docs>
